export default "__VITE_ASSET__a1a40cf7__"